// prettier-ignore
export const Homepage = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
    <path fill="currentColor" fillRule="evenodd" d="M9.47 1.69a.85.85 0 0 1 1.06 0l6.38 5.1c.2.16.32.4.32.66v10.2c0 .47-.39.85-.86.85H3.63a.85.85 0 0 1-.85-.85V7.45c0-.26.11-.5.31-.66l6.38-5.1ZM8.73 16.8h2.54v-3.83H8.73v3.83Zm4.24 0v-4.68a.85.85 0 0 0-.85-.84H7.88a.85.85 0 0 0-.85.85v4.67H4.48V7.86L10 3.44l5.53 4.42v8.94h-2.55Z" clipRule="evenodd"/>
  </svg>
)
